import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import { useCanonicalUrl } from '@/legacy-src/hooks/useCanonicalUrl'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import LoginContainer from '../../legacy-src/containers/LoginContainer'

const Login = () => {
  const router = useRouter()
  const { t } = getTranslate()

  const therapistId = parseInt(router.query.therapistId as string, 10)
  const canonicalUrl = useCanonicalUrl()

  return (
    <>
      <Head>
        <title>{t('headers.login')}</title>
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <LoginContainer {...{ therapistId }} />
    </>
  )
}

export default Login
